import React, { useState, useEffect, useCallback } from "react";
import { Link } from "react-router-dom";
import { Phone, ChevronLeft, ChevronRight, ArrowRight } from "lucide-react";
import { heroSlides, business } from "../mock";

const Hero = () => {
  const [current, setCurrent] = useState(0);

  const next = useCallback(() => setCurrent((c) => (c + 1) % heroSlides.length), []);
  const prev = () => setCurrent((c) => (c - 1 + heroSlides.length) % heroSlides.length);

  useEffect(() => {
    const t = setInterval(next, 5000);
    return () => clearInterval(t);
  }, [next]);

  return (
    <section className="relative h-[88vh] min-h-[560px] overflow-hidden bg-[#1a1a1a]">
      {heroSlides.map((slide, i) => (
        <div
          key={i}
          className={`absolute inset-0 transition-opacity duration-1000 ${i === current ? "opacity-100" : "opacity-0"}`}
        >
          <img
            src={slide.image}
            alt={`${slide.title} in Sydney \u2013 Dentcraft NSW paintless dent removal`}
            className={`w-full h-full object-cover ${i === current ? "animate-kenburns" : ""}`}
          />
          <div className="absolute inset-0 bg-gradient-to-r from-black/85 via-black/55 to-black/25" />
        </div>
      ))}

      {/* Content */}
      <div className="relative z-10 h-full max-w-7xl mx-auto px-6 flex flex-col justify-center">
        <div className="max-w-2xl">
          <span key={current} className="animate-fade-up inline-flex items-center gap-2 bg-[#84bd00]/20 border border-[#84bd00]/40 text-[#a8e63a] text-xs font-semibold tracking-widest uppercase px-4 py-1.5 rounded-full">
            {heroSlides[current].title} &middot; {heroSlides[current].sub}
          </span>
          <h1 className="mt-6 text-white font-display font-extrabold text-4xl md:text-6xl leading-tight">
            Paintless Dent Removal Sydney
          </h1>
          <p className="mt-5 text-gray-200 text-lg md:text-xl max-w-xl">
            Mobile paintless dent removal across Western Sydney and Sydney Metro. {business.tagline} restoring your car's factory finish, on-site.
          </p>
          <div className="mt-9 flex flex-wrap items-center gap-4">
            <a
              href={`tel:${business.phoneRaw}`}
              className="inline-flex items-center gap-2 bg-[#84bd00] hover:bg-[#75a800] text-white font-semibold px-7 py-3.5 rounded-lg transition-colors shadow-lg shadow-[#84bd00]/30"
            >
              <Phone size={18} /> {business.phone}
            </a>
            <Link
              to="/contact"
              className="inline-flex items-center gap-2 bg-white/10 hover:bg-white/20 backdrop-blur border border-white/30 text-white font-semibold px-7 py-3.5 rounded-lg transition-colors"
            >
              Get a Free Quote <ArrowRight size={18} />
            </Link>
          </div>
        </div>
      </div>

      {/* Controls */}
      <button onClick={prev} className="absolute left-4 top-1/2 -translate-y-1/2 z-20 w-11 h-11 rounded-full bg-white/10 hover:bg-[#84bd00] backdrop-blur border border-white/20 text-white flex items-center justify-center transition-colors">
        <ChevronLeft size={22} />
      </button>
      <button onClick={next} className="absolute right-4 top-1/2 -translate-y-1/2 z-20 w-11 h-11 rounded-full bg-white/10 hover:bg-[#84bd00] backdrop-blur border border-white/20 text-white flex items-center justify-center transition-colors">
        <ChevronRight size={22} />
      </button>

      {/* Dots */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-20 flex gap-3">
        {heroSlides.map((_, i) => (
          <button
            key={i}
            onClick={() => setCurrent(i)}
            className={`h-2.5 rounded-full transition-all ${i === current ? "w-8 bg-[#84bd00]" : "w-2.5 bg-white/50 hover:bg-white"}`}
          />
        ))}
      </div>
    </section>
  );
};

export default Hero;
